const actions = {
  SET_STATE: 'downloads/SET_STATE',
  FETCH_ALL_DOWNLOADS: 'downloads/FETCH_ALL_DOWNLOADS',
  DELETE_SINGLE_DOWNLOAD: 'downloads/DELETE_SINGLE_DOWNLOAD',
}

export default actions
